"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complex_utils_1 = require("complex-utils");
const old_1 = __importDefault(require("../api/old"));
const old = {
    getUrl() {
        // return getEnvMode('data') === 'prod' ? 'https://fls.feidifl.com/ufo/logonCS.html' : 'https://testfls.feidifl.com/ufo/logonCS.html'
        return (0, complex_utils_1.getEnvMode)('data') === 'prod' ? ' http://114.116.252.14/ufo/logonCS.html' : 'http://124.70.80.135/ufo/logonCS.html';
    },
    getToken() {
        return new Promise((resolve, reject) => {
            old_1.default.getToken.require().then(res => {
                resolve(res);
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    },
    toContract(contractNumber) {
        return new Promise((resolve, reject) => {
            this.getToken().then(res => {
                const url = (0, complex_utils_1.formatQueryUrl)(this.getUrl(), {
                    csVt: res.data.data,
                    csUrl: 'ContractInfoAllView',
                    csParam: contractNumber
                });
                window.open(url, '_blank');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    },
    toSettlement(settlementTaskno) {
        return new Promise((resolve, reject) => {
            this.getToken().then(res => {
                const url = (0, complex_utils_1.formatQueryUrl)(this.getUrl(), {
                    csVt: res.data.data,
                    csUrl: 'EarlySettlementDetail',
                    csParam: settlementTaskno
                });
                window.open(url, '_blank');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    },
    toPaymentProcess() {
        return new Promise((resolve, reject) => {
            this.getToken().then(res => {
                const url = (0, complex_utils_1.formatQueryUrl)(this.getUrl(), {
                    csVt: res.data.data,
                    csUrl: 'RentRecoveryApply',
                    csParam: ''
                });
                window.open(url, '_blank');
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
};
exports.default = old;
